var React = require('react');

function IconTooltipWhite (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd","transform":"translate(1 1)"},[React.createElement("circle",{"cx":"7","cy":"7","r":"7","stroke":"#fff","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"fill":"#fff","fillRule":"nonzero","d":"M7.5 7.066V8.29H6.303V6.184h.657c.45 0 .764-.234.764-.72 0-.432-.288-.738-.729-.738-.603 0-.729.504-.729.837H5.051c-.027-.612.244-1.881 1.944-1.881 1.26 0 1.945.783 1.945 1.773 0 .936-.621 1.548-1.44 1.611zm-.595 3.024a.759.759 0 0 1-.764-.765c0-.423.341-.756.764-.756a.75.75 0 0 1 .756.756.751.751 0 0 1-.755.765z","key":1})]));
}

IconTooltipWhite.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16"};

module.exports = IconTooltipWhite;

IconTooltipWhite.default = IconTooltipWhite;
